import WalletListViewPage from '../containers/Wallet/List/View/View'  
import Header from '../components/Header/Header' 
import SidebarPage from '../components/Sidebar/Sidebar'
import { MainContainer } from '../components/common/Containers'  
 
const WalletListView = () => {

    return ( 
        <>  
            <SidebarPage />
            <MainContainer>    
                <Header /> 
                <main> 
                    <WalletListViewPage/>  
                </main> 
            </MainContainer>
        </>
    )
}

export default WalletListView
